const isoToDateInputValue = (isoDate: string) => {
  return isoDate ? isoDate.split("T")[0] : "";
};

export default isoToDateInputValue;
